import type { TEntityId, IEntityDataItem } from '~/types/models'
import type { IFieldSetField } from '~/types/fieldSet/models'

export async function ensureUniqueness({
  callingMn,
  sourceEntityId,
  sourceEntityFlagPropertyName,
  sourceEntityArray,
  sourceEntityData,
  finallyFn = () => {},
}: {
  callingMn: string
  sourceEntityId: TEntityId
  sourceEntityFlagPropertyName: string
  sourceEntityArray: IEntityDataItem[] | IFieldSetField[]
  sourceEntityData: Partial<IEntityDataItem>
  finallyFn?: Function
}): Promise<boolean> {
  const fn =
    `${callingMn} --> [cynqueModules/ensureUniqueness] |` +
    ` ${ensureUniqueness.name}`
  if (!sourceEntityData.hasOwnProperty(sourceEntityFlagPropertyName)) {
    console.debug(`${fn} does NOT include ${sourceEntityFlagPropertyName}`)
    return false
  }
  console.debug(
    `${fn} includes ${sourceEntityFlagPropertyName}` +
      ` (${sourceEntityData[sourceEntityFlagPropertyName]})`
  )
  if (sourceEntityData[sourceEntityFlagPropertyName] === true) {
    console.debug(
      `${fn} ${sourceEntityFlagPropertyName} in source entity is true.` +
        ` Clearing value in other objects.`
    )
    // clear flag (typically checkbox) value in other rows
    sourceEntityArray
      .filter(
        (se: IEntityDataItem | IFieldSetField) => se.id !== sourceEntityId
      )
      .forEach((se: IEntityDataItem | IFieldSetField) => {
        se[sourceEntityFlagPropertyName] = false
      })
  }
  await finallyFn()
  return true
}
